<div class="row">
  <div class="col-md-12">
    <app-tabela titulo="Lista de Orçamentos"
                placeHolder="Buscar orçamentos"
                [colunas]="colunas"
                [linhas]="linhas"
                [botaoEditar]="false"
    ></app-tabela>
  </div>
</div>
